(($, duo) => {
  Drupal.behaviors.testimonialcarousel= {

    attach: function(context, settings) {
      if (context !== document) {
        return;
      }

      this.init(context, settings);
    },

    init: function(context, settings) {

      /* setup testimonial carousel */
      /* ************************** */

      const $testimonialList = $('.testimonial-list');
      $testimonialList.each(function() {

        let numberOfItems = $(this).find('.testimonial-list__item').length;

        // Check if a carousel is needed (for one item this isn't)
        if(numberOfItems > 1) {

          // Options
          // -> avoid drag on desktops without touch:
          let sliderDraggable = false;
          if(duo.Utils.isTouchEnabled()) {
            sliderDraggable = true;
          }

          // Carousel
          let $carousel = $(this).flickity({
            cellSelector: '.testimonial-list__item',
            fade: true,
            adaptiveHeight: true,
            draggable: sliderDraggable,
            arrowShape: 'm87.5 45.832h-58.75l17.918-17.914-5.8359-5.8359-27.914 27.918 27.914 27.918 5.8359-5.8359-17.918-17.914h58.75z',
          });

          // Add container for each item where the previous and next button need to be in 
          let $previousDisabled = $(this).find('.flickity-button.previous').clone().attr('disabled', true)[0].outerHTML;
          let $nextDisabled = $(this).find('.flickity-button.next').clone().attr('disabled', true)[0].outerHTML;
          let $previous = $(this).find('.flickity-button.previous').clone().attr('disabled', false)[0].outerHTML;
          let $next = $(this).find('.flickity-button.next').clone().attr('disabled', false)[0].outerHTML;

          // Loop over each element inside the carousel and set the previous and next buttons good (regarding the HTML element attributes)
          $(this).find('.testimonial-list__item').each(function(key, item) {

            let $contentBlock = $(this).find('.testimonial-teaser__content-block');

            if(key === 0) { // First item
              $contentBlock.append('<div class="paragraph__testimonial__buttons">' + $previousDisabled + $next + '</div>');
            } else if (key === numberOfItems - 1) { // Last item
              $contentBlock.append('<div class="paragraph__testimonial__buttons">' + $previous + $nextDisabled + '</div>');
            } else { // All the other items
              $contentBlock.append('<div class="paragraph__testimonial__buttons">' + $previous + $next + '</div>');
            }
          });

          // -> reinitalize, because sometimes flickity gets "stuck":
          $carousel.flickity('resize');

          // Add click events on the previous and next buttons inside the content
          $('.testimonial-teaser__content-block .previous').on( 'click', function() {
            $carousel.flickity('previous');
          });
          $('.testimonial-teaser__content-block .next').on( 'click', function() {
            $carousel.flickity('next');
          });
        }
      });

      /* empty event listener: */
      /* -> the following makes flickity work better on ios
        *    see: https://github.com/metafizzy/flickity/issues/457#issuecomment-254501356
        *    "iOS 10 has a bug where event.preventDefault() will not cancel window scrolling. 
        *     You can fix this behavior by adding an innocuous event handler."
        * -> when there's an update of flickity, this may no longer be needed
        */
      window.addEventListener('touchmove', function() {});
    },

  };
})(jQuery, window.duo = window.duo || {});
